export default "__VITE_ASSET__BifBi9fj__"